import { render, staticRenderFns } from "./VenueDetails.vue?vue&type=template&id=1763804d&scoped=true&"
import script from "./VenueDetails.vue?vue&type=script&lang=js&"
export * from "./VenueDetails.vue?vue&type=script&lang=js&"
import style0 from "./VenueDetails.vue?vue&type=style&index=0&id=1763804d&prod&scoped=true&lang=css&"
import style1 from "./VenueDetails.vue?vue&type=style&index=1&id=1763804d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763804d",
  null
  
)

export default component.exports